import styled from "styled-components";
import { useCallback } from "react";
import { ReactComponent as CheckboxComplete } from "../Images/icons/Checkbox-Complete.svg";
import { ReactComponent as CheckboxError } from "../Images/icons/Checkbox-Error.svg";
import { ReactComponent as CheckboxIncomplete } from "../Images/icons/Checkbox-Incomplete.svg";
import { ColorVariables } from "../Colors";

const StyledButton = styled.button<CheckboxProps>`
  width: ${(props) => props.size}px;
  height: ${(props) => props.size}px;
`;

const StyledCheckboxAndLabel = styled.button<CheckboxProps>`
  display: flex;
  align-items: center;
  svg {
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    margin-right: 10px;
  }
  p {
    text-align: left;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    color: ${ColorVariables.coco7};
  }
`;

export type CheckboxProps = {
  name: string;
  size?: number;
  onClick?: (boolean) => any;
  checked?: boolean;
  error?: boolean;
  label?: JSX.Element;
};

export default function Checkbox({ onClick, name, size = 30, checked = false, error = false, label }: CheckboxProps) {
  const svgParams = {
    width: size,
    height: size,
  };

  const checkboxIcon = useCallback(() => {
    if (checked) {
      return <CheckboxComplete data-name="checkboxComplete" {...svgParams} />;
    }
    if (error) {
      return <CheckboxError data-name="checkboxError" {...svgParams} />;
    }
    return <CheckboxIncomplete data-name="checkboxIncomplete" {...svgParams} />;
  }, [checked, error]);

  const handleClick = useCallback(() => {
    if (onClick) {
      onClick(!checked);
    }
  }, [onClick]);

  if (label) {
    return (
      <StyledCheckboxAndLabel data-name={name} name={name} size={size} type="button" onClick={handleClick}>
        {checkboxIcon()}
        <p className="label">{label}</p>
      </StyledCheckboxAndLabel>
    );
  }

  return (
    <StyledButton data-name={name} name={name} size={size} type="button" onClick={handleClick}>
      {checkboxIcon()}
    </StyledButton>
  );
}
